import { Input } from '../ui/Input';

interface Props {
  label: string;
  value: string;
  onChange: (v: string) => void;
  required?: boolean;
  min?: string;
  max?: string;
}

export function DateField({ label, value, onChange, required, min, max }: Props) {
  return (
    <Input
      type="date"
      label={`${label}${required ? ' *' : ''}`}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      min={min}
      max={max}
    />
  );
}
